export * from './getQueryParam';
